"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const domain_1 = require("@oolio-group/domain");
const utils_1 = require("../utils");
/**
 * Assigns a customer to an order with the customer id
 * @param event of type InitiateOrderEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    const order = (0, utils_1.clone)(prevState);
    if (order.source !== domain_1.IntegrationApps.KIOSK &&
        !(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    const customer = {
        id: event.customerId,
        firstName: event.firstName,
        lastName: event.lastName,
        email: event.email,
        phone: event.phone,
        loyaltyMember: Boolean(event.loyaltyMember),
    };
    if (event.customerAccountDetails) {
        customer.customerAccountDetails = event.customerAccountDetails;
    }
    order.customer = customer;
    order.isLoyaltyApplied = Boolean(event === null || event === void 0 ? void 0 : event.isLoyaltyApplied);
    return order;
}
exports.default = default_1;
//# sourceMappingURL=assignCustomer.js.map